import React, { useMemo } from "react";
import { isServerSideRender } from "@nf/helpers";
import styles from "./GenresScreen.module.scss";
import { DotsLoader } from "../../components/DotsLoader";
import InfiniteScroll from "react-infinite-scroll-component";
import { IMediaListModel } from "@nf/common";

export type TInfiniteScrollWrapperProps = {
  children: React.ReactNode;
  mediaList: IMediaListModel;
  getMore: () => void;
};

const SCROLL_THRESHOLD = 0.6;

export const InfiniteScrollWrapper: React.FC<TInfiniteScrollWrapperProps> = ({
  children,
  mediaList,
  getMore,
}) => {
  const hasMore = useMemo(() => {
    return (
      !mediaList.IsLoading &&
      !!mediaList.Entities &&
      mediaList?.Entities.length < mediaList.TotalCount
    );
  }, [mediaList]);

  return isServerSideRender ? (
    <div className={styles.content}>{children}</div>
  ) : (
    <InfiniteScroll
      className={styles.container}
      dataLength={mediaList?.Entities?.length || 0}
      next={getMore}
      hasMore={hasMore}
      scrollThreshold={SCROLL_THRESHOLD}
      loader={
        <div className={styles.loader}>
          <DotsLoader width={75} />
        </div>
      }
    >
      {children}
    </InfiniteScroll>
  );
};
